import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const { contentAlignment, buttonAlignment, blockId } = attributes;
	const blockProps = useBlockProps.save( {
		className: `block-${ blockId ?? 'buttons' }`,
		style: {
			display: 'flex',
			flexDirection: buttonAlignment === 'vertical' ? 'column' : 'row',
			justifyContent: contentAlignment,
		},
	} );

	return (
		<div { ...blockProps }>
			<InnerBlocks.Content />
		</div>
	);
}
